<template>
	<nav class="page-sidebar" data-pages="sidebar">
    <div class="sidebar-header">
      <router-link :to="{ name: 'dashboard.index'}"><img src="../../../static/img/logo-white.svg" alt="logo" class="brand" width="180px">
      </router-link>
      <!-- <div class="sidebarCollapse">
        <img src="../../../static/img/sidebar-collapse.svg" alt="icon">
      </div> -->
      <div aria-label="Pin Menu" type="button"  class="sidebarCollapse"><i class="pg-icon"></i></div>
    </div>
    <div class="sidebar-menu">
      <ul class="menu-items">
        <router-link id="sidebar-dashboard" class="hide_after_click" data-intro="Get a birds eye view of all important metrics." data-position='right' tag="li" :to="{ name: 'dashboard.index'}" v-if="user_permission.data.dashboard">
          <a href=""><span class="title">Dashboard</span>
          <span class="arrow invisible"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-home"></i></span>
        </router-link>
        <router-link tag="li" class="hide_after_click" :to="{ name: 'dashboard.companylist'}" v-if="user_permission.data.status==2">
          <a href=""><span>Login As Company</span></a>
					<span class="icon-thumbnail"><i class="far fa-newspaper"></i></span>
        </router-link>
        <router-link id="sidebar-calendar" tag="li" class="hide_after_click" title="Schedule Calendar" :to="{ name: 'schedule_calendar'}">
          <a href=""><span>Calendar</span></a>
					<span class="icon-thumbnail"><i class="fas fa-calendar-alt"></i></span>
        </router-link>
        <li id="sidebar-campaign"  data-intro="Create and manage Phishing simulation campaigns." data-position='right' v-if="user_permission.data.campaign_create || user_permission.data.campaign_view || user_permission.data.campaign_schedule">
          <a href="javascript:;"><span class="title">Campaigns</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="far fa-newspaper"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'campaigns.create'}" :class="checkActive($route.path==='/campaigns/create')" v-if="user_permission.data.campaign_create">
              <a>Add Campaign</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link v-if="needlePhishingStatus" class="hide_after_click" tag="li" :to="{ name: 'create_needle_phishing'}">
              <a >Add Needle Phishing</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
           <!--  <router-link class="hide_after_click" tag="li" :to="{ name: 'campaigns'}" v-if="user_permission.data.campaign_view">
              <a >View Campaign</a>
              <span class="icon-thumbnail">V</span>
            </router-link>-->
            <router-link class="hide_after_click" tag="li" :to="{ name: 'campaigns'}" :class="checkActive($route.path==='/campaigns')" v-if="user_permission.data.campaign_view">
              <a >View Campaign</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'bulk_campaigns'}" v-if="user_permission.data.campaign_schedule">
              <a>Schedule Campaigns</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/campaigns/creator-workspace' }" v-if="userRole=='creator'">
              <a>Campaigns Workspace</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/campaigns/approver-workspace' }"  v-if="userRole=='approver'">
              <a>Campaigns Workspace</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-announcement"  data-intro="Use this to create and manage Announcements, eAUP or internal communication." data-position='right' v-if="user_permission.data.announcement_create || user_permission.data.announcement_view">
          <a href="javascript:;"><span class="title">Announcements</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fa fa-bullhorn"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ path: '/announcements/create'}" :class="checkActive($route.path==='/announcements/create')" v-if="user_permission.data.announcement_create">
              <a>Add Announcement</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/announcements'}" :class="checkActive($route.path==='/announcements')" v-if="user_permission.data.announcement_view">
              <a>View Announcement</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
             <router-link tag="li" class="hide_after_click" :to="{ path: '/announcements/creator-workspace' }" v-if="userRole=='creator'">
              <a>Announcement Workspace</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/announcements/approver-workspace' }"  v-if="userRole=='approver'">
              <a>Announcement Workspace</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-policy"  data-intro="Policy" data-position='right' v-if="user_permission.data.policy_create || user_permission.data.policy_view">
          <a href="javascript:;"><span class="title">Policy</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fa fa-file"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ path: '/policy/create'}" :class="checkActive($route.path==='/policy/create')" v-if="user_permission.data.policy_create">
              <a>Add Policy</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/policy'}" :class="checkActive($route.path==='/policy')" v-if="user_permission.data.policy_view">
              <a>View Policy</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/policy/creator-workspace' }" v-if="userRole=='creator'">
              <a>Policy Workspace</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/policy/approver-workspace' }"  v-if="userRole=='approver'">
              <a>Policy Workspace</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
          </ul>
        </li>
        <li id="adobe_acrobat"  data-intro="adobe_acrobat" data-position='right' v-if="adobeAcrobatStatus">
          <a href="javascript:;"><span class="title">Adobe Acrobat</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fa fa-file"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ path: '/add-agreement'}" :class="checkActive($route.path==='/add-agreement')">
              <a>Add Agreement</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/view-agreements'}" :class="checkActive($route.path==='/view-agreements')">
              <a>View Agreement</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ path: '/adobe-auth'}" :class="checkActive($route.path==='/adobe-auth')">
              <a>Settings</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-scenario" data-intro="Create and manage Scenarios for Phishing Simulation and Announcement campaigns." data-position='right' v-if="user_permission.data.view_scenario || user_permission.data.add_scenario">
          <a href="javascript:;"><span class="title">Scenarios</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-file-contract"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'scenario.description'}" :class="checkActive($route.path==='/scenario/description')" v-if="user_permission.data.add_scenario">
              <a>Add Scenario</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'scenario'}" :class="checkActive($route.path==='/scenario')" v-if="user_permission.data.view_scenario">
              <a>View Scenarios</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-training" v-if="user_permission.data.view_modules || user_permission.data.upload_modules || user_permission.data.direct_learning_management || user_permission.data.education_uploader || user_permission.data.is_education_editable">
          <a href="javascript:;"><span class="title">Training</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="far fa-file-alt"></i></span>
          <ul class="sub-menu">
          <router-link tag="li" class="hide_after_click" :to="{ name: 'trainingmoduleAdmin'}" v-if="user_permission.data.is_education_editable">
              <a>View Training (Super Admin)</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'trainingmodule'}" v-if="user_permission.data.view_modules">
              <a>View Training</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'bulkeducation'}"  v-if="user_permission.data.upload_modules">
              <a>Upload Training</a>
              <span class="icon-thumbnail">U</span>
            </router-link>
            <!-- <router-link tag="li" class="hide_after_click" :to="{ name: 'directlearning'}"  v-if="user_permission.data.enrolments">
              <a>Enrolments</a>
              <span class="icon-thumbnail">E</span>
            </router-link> -->
            <router-link tag="li" class="hide_after_click" :to="{ name: 'training_settings'}" v-if="user_permission.data.settings">
              <a>Settings</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-lms" oncontextmenu="return false;" @click="redirectToLms()" v-if="user_permission.data.lms">
          <a href="javascript:;"><span class="title">LMS</span>
          <span class="arrow invisible"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-graduation-cap"></i></span>
        </li>
        <li class="AIIcon" id="sidebar-lms" v-if="needlePhishingStatus"  oncontextmenu="return false;" @click="redirectToHFv3()" >
          <a href="javascript:;"><span class="title">HFAI</span>
          <span class="arrow invisible"></span></a>
          <span class="icon-thumbnail"><img src="../../../static/img/ai.png"/></span>
        </li>
        <li id="sidebar-recipients" data-intro="Manage your recipients here." data-position='right' v-if="user_permission.data.view_recepients || user_permission.data.add_new_recepients || user_permission.data.manage_groups || user_permission.data.add_suppression || user_permission.data.view_suppression">
          <a href="javascript:;"><span class="title">Recipients</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-users"></i></span>
          <ul class="sub-menu">
            <router-link  tag="li" class="hide_after_click" :to="{ name: 'recipients'}" v-if="user_permission.data.view_recepients">
              <a>View Recipients</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'recipients.imports'}" v-if="user_permission.data.add_new_recepients">
              <a>Add New Recipients</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'recipients.manage_groups'}" v-if="user_permission.data.manage_groups">
              <a>Manage Groups</a>
              <span class="icon-thumbnail">M</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'recipients.suppression.imports'}" v-if="user_permission.data.view_suppression">
              <a>Suppression List</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'suppression'}" v-if="user_permission.data.add_suppression">
              <a>Suppressed Recipients</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'recipients.ouSetting'}" v-if="user_permission.data.view_recepients && ouSettingStatus">
              <a>OU Settings</a>
              <span class="icon-thumbnail">O</span>
            </router-link>
          </ul>
        </li>
      <!-- <li id="sidebar-reports" data-intro="View all your reports here in real time!" data-position='right' v-if="user_permission.data.all_reports || user_permission.data.campaign_reports || user_permission.data.announcement_reports || user_permission.data.detailed_report || user_permission.data.view_leaderboard || user_permission.data.view_laggards || user_permission.data.vulnerability_trend || user_permission.data.awareness_trend || user_permission.data.reporting_trend || user_permission.data.weakest_links || user_permission.data.strongest_links || user_permission.data.weakest_departments || user_permission.data.high_risk_users || user_permission.data.department_compromise || user_permission.data.designation_compromise">
          <a href="javascript:;"><span class="title">Reports</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-chart-line"></i></span>
          <ul class="sub-menu">
            <router-link  tag="li" class="hide_after_click" v-if="user_permission.data.all_reports" :to="{ name: 'report.campaigns'}">
              <a>All Reports</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link  tag="li" class="hide_after_click" v-if="user_permission.data.campaign_reports" :to="{ name: 'report.allcampaigns'}">
              <a>Campaign Reports</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link  tag="li" class="hide_after_click" v-if="user_permission.data.announcement_reports" :to="{ name: 'report.allannouncements'}">
              <a>Announcement Reports</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link  tag="li" class="hide_after_click" v-if="user_permission.data.detailed_report" :to="{ name: 'report.detailedreporting'}">
              <a>Detailed Report</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.view_leaderboard" :to="{ name: 'leaderboard'}">
              <a>View LeaderBoard</a>
              <span class="icon-thumbnail">L</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.view_laggards" :to="{ name: 'laggards'}" >
              <a>View Laggards</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.vulnerability_trend" :to="{ name: 'managementreport.phishingvulnerability'}">
              <a>Vulnerability Trend</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.awareness_trend" :to="{ name: 'managementreport.awarenesstrendslook'}">
              <a>Awareness Trend</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.reporting_trend" :to="{ name: 'managementreport.reportingtrend'}">
              <a>Reporting Trend</a>
              <span class="icon-thumbnail">R</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.weakest_links" :to="{ name: 'managementreport.weakest'}">
              <a>Weakest Links</a>
              <span class="icon-thumbnail">W</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.strongest_links" :to="{ name: 'managementreport.strongest'}">
              <a>Strongest Links</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.weakest_departments" :to="{ name: 'managementreport.departmentweakest'}">
              <a>Weakest Departments</a>
              <span class="icon-thumbnail">W</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.high_risk_users" :to="{ name: 'managementreport.highrisk'}">
              <a>High Risk Users</a>
              <span class="icon-thumbnail">H</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.department_compromise" :to="{ name: 'managementreport.departmentcompromise'}">
              <a>Department Compromise</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.designation_compromise" :to="{ name: 'managementreport.designationcompromise'}">
              <a>Designation Compromise</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
          </ul>
        </li> -->
        <li id="sidebar-reports-new"  v-if="user_permission.data.phishing_campaigns_new || user_permission.data.announcement_campaigns_new || this.user_permission.data.policy_announcement_new || user_permission.data.leaderboard_new || user_permission.data.laggardsnew || user_permission.data.all_reports">
          <a href="javascript:;"><span class="title title_sup">Reports<sup>New</sup></span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-chart-line"></i></span>
          <ul class="sub-menu">
           <router-link  tag="li" class="hide_after_click" :to="{ name: 'reports.phishingcampaignsperformance'}" v-if="user_permission.data.phishing_campaigns_new">
              <a>Phishing Campaigns</a>
              <span class="icon-thumbnail">P</span>
            </router-link>
            <router-link  tag="li" class="hide_after_click" :to="{ name: 'reports.announcementcampaignsperformance'}" v-if="user_permission.data.announcement_campaigns_new">
              <a>Announcement Campaigns</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link  tag="li" class="hide_after_click" :to="{ name: 'reports.policyannouncementperformance'}" v-if="user_permission.data.policy_announcement_new">
              <a>Policy Announcement</a>
              <span class="icon-thumbnail">P</span>
            </router-link>
             <router-link tag="li" class="hide_after_click" :to="{ name: 'reports.leaderboard'}" v-if="user_permission.data.leaderboard_new">
              <a>Leaderboard</a>
              <span class="icon-thumbnail">L</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'reports.laggards'}" v-if="user_permission.data.laggardsnew">
              <a>Laggards</a>
              <span class="icon-thumbnail">L</span>
            </router-link>
             <router-link  tag="li" class="hide_after_click" :to="{ name: 'report.campaigns-detailed-report'}" v-if="user_permission.data.detailed_new">
              <a>Detailed</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.weakest_departments_new" :to="{ name: 'managementreport.repeatoffenders'}">
              <a>Repeatedly Phished Users </a>
              <span class="icon-thumbnail">R</span>
            </router-link>
           </ul>
        </li>
        <li id="sidebar-management-reports" v-if="user_permission.data.vulnerability_trend_new || user_permission.data.awareness_trend_new || user_permission.data.reporting_trend_new || user_permission.data.weakest_links_new || user_permission.data.strongest_links_least_compromised_new || user_permission.data.strongest_links_most_compromised_new || user_permission.data.weakest_departments_new">
          <a href="javascript:;"><span class="title title_new"><small>New</small>Management Reports</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-chart-line"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.vulnerability_trend_new" :to="{ name: 'managementreport.phishingvulnerabilitytrend'}">
              <a>Vulnerability Trend</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.awareness_trend_new" :to="{ name: 'managementreport.cybersecurityawarenesstrend'}">
              <a>Awareness Trend</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.reporting_trend_new" :to="{ name: 'managementreport.phishingreportingtrend'}">
              <a>Reporting Trend</a>
              <span class="icon-thumbnail">R</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.weakest_links_new" :to="{ name: 'managementreport.weakestlinks'}">
              <a>Weakest Links</a>
              <span class="icon-thumbnail">W</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.strongest_links_least_compromised_new" :to="{ name: 'managementreport.strongestlinks-least-compromised'}">
              <a>Strongest Links (Least Compromised)</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" v-if="user_permission.data.strongest_links_most_compromised_new" :to="{ name: 'managementreport.strongestlinks-most-reported'}">
              <a>Strongest Links (Most Reported)</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
             <router-link tag="li" class="hide_after_click" v-if="user_permission.data.weakest_departments_new" :to="{ name: 'managementreport.weakestdepartments'}">
              <a>Weakest Departments </a>
              <span class="icon-thumbnail">W</span>
            </router-link>
           </ul>
        </li>
         <li id="sidebar-vulnerability-reports" v-if="user_permission.data.departments_new || user_permission.data.designations_new">
          <a href="javascript:;"><span class="title title_new"><small>New</small>Vulnerability Reports</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-chart-line"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'newreports.VulnerabilityReport-DepartmentWiseUniqueEmployees'}" v-if="user_permission.data.departments_new">
              <a>Departments</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'newreports.VulnerabilityReport-DesignationWiseUniqueEmployees'}" v-if="user_permission.data.designations_new">
              <a>Designations</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            </ul>
        </li>

        <li id="sidebar-vcro" v-if="user_permission.data.organisation_vcro || user_permission.data.departments_vcro || user_permission.data.groups_vcro || user_permission.data.users_vcro">
          <a href="javascript:;" title="Virtual Cyber Risk Officer"><span class="title title_sup">vCRO<sup>New</sup></span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-exclamation-triangle"></i></span>
          <ul class="sub-menu">
            <router-link title="Risk Score of the Organisation." tag="li" class="hide_after_click" v-if="user_permission.data.organisation_vcro" :to="{ name: 'vcro.organisation_risk_score'}">
              <a> Organisation</a>
              <span class="icon-thumbnail">O</span>
            </router-link>
            <router-link title="Risk Score of all the departments of the organisation." tag="li" class="hide_after_click" v-if="user_permission.data.departments_vcro" :to="{ name: 'vcro.all_department_risk_score'}">
              <a> Departments</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link title="Risk Score of all the groups of the organisation." tag="li" class="hide_after_click" v-if="user_permission.data.groups_vcro" :to="{ name: 'vcro.all_group_risk_score'}">
              <a> Groups</a>
              <span class="icon-thumbnail">G</span>
            </router-link>
            <router-link title="Risk Score of all the users of the organisation." tag="li" class="hide_after_click" v-if="user_permission.data.users_vcro" :to="{ name: 'vcro.all_user_risk_score'}">
              <a> Users </a>
              <span class="icon-thumbnail">U</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-gamification" v-if="user_permission.data.gamification_add_badgee || user_permission.data.gamification_award_log || user_permission.data.gamification_badges || user_permission.data.gamification_set_points">
          <a href="javascript:;" title="Gamification"><span class="title title_new"> <small>New</small> Gamification Engine</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-gamepad"></i></span>
          <ul class="sub-menu">
            <router-link title="" tag="li" class="hide_after_click" v-if="user_permission.data.gamification_badges" :to="{ name: 'gamification.badges'}">
              <a>Badges</a>
              <span class="icon-thumbnail">B</span>
            </router-link>
            <router-link title="" tag="li" class="hide_after_click" v-if="user_permission.data.gamification_add_badgee" :to="{ name: 'gamification.add_badge'}">
              <a>Add Badge</a>
              <span class="icon-thumbnail">B</span>
            </router-link>
            <router-link title="" tag="li" class="hide_after_click" v-if="user_permission.data.gamification_award_log" :to="{ name: 'gamification.award_log_all'}">
              <a>Award Log</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link title="" tag="li" class="hide_after_click" v-if="user_permission.data.gamification_set_points" :to="{ name: 'gamification.points'}">
              <a>Set Points</a>
              <span class="icon-thumbnail">S</span>
            </router-link>
            <router-link title="" tag="li" class="hide_after_click" v-if="user_permission.data.gamification_set_points" :to="{ name: 'gamification.gamification_notification'}">
              <a>Notification Emails</a>
              <span class="icon-thumbnail">N</span>
            </router-link>
          </ul>
        </li>
        <li v-if="(user_permission.data.myUserportal || user_permission.data.myUserportal_view_as || user_permission.data.customise_user_portal || user_permission.data.customise_login_page || user_permission.data.news_updates) && (showBoth || user_permission.data.userportal_active_version.userportal ==='v1')">
          <a id="sidebar-user-portal" href="javascript:;" title="User Portal"><span class="title title_sup">User Portal</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-user"></i></span>
          <ul class="sub-menu">
            <li title="My User Portal" tag="li" class="hide_after_click" v-if="myUserportal" >
              <a :href="myUserportal" >My User Portal</a>
              <span class="icon-thumbnail">U</span>
            </li>
            <router-link title="View As" v-if="user_permission.data.myUserportal_view_as"  tag="li" class="hide_after_click" :to="{ name: 'viewas'}">
              <a>View As</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link title="Customise User Portal" v-if="user_permission.data.customise_user_portal"  tag="li" class="hide_after_click" :to="{ name: 'customize'}">
              <a>Customise User Portal</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link title="Customise Login Page" v-if="user_permission.data.customise_login_page"  tag="li" class="hide_after_click" :to="{ name: 'customize_login'}">
              <a>Customise Login Page</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link title="News Updates" tag="li" v-if="user_permission.data.news_updates"  class="hide_after_click" :to="{ name: 'news_updates'}">
              <a>News Updates</a>
              <span class="icon-thumbnail">N</span>
            </router-link>
          </ul>
        </li>

        <!--
          all_reports is in this gate because Portal Logins lives in here now: without it, an
          admin who has reporting rights but none of the five user-portal rights would lose the
          only link to a page they are still allowed to open.
        -->
        <li v-if="(user_permission.data.myUserportal || user_permission.data.myUserportal_view_as || user_permission.data.customise_user_portal || user_permission.data.customise_login_page || user_permission.data.news_updates || user_permission.data.all_reports) && (showBoth || user_permission.data.userportal_active_version.userportal ==='v2')">
          <a id="sidebar-user-portal" href="javascript:;" title="User Portal"><span class="title title_sup">User Portal - V2<sup>New</sup></span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-user"></i></span>
          <ul class="sub-menu">
            <!-- <li title="My User Portal" tag="li" class="hide_after_click" v-if="myUserportal" >
              <a :href="endUserPortal" >My User Portal</a>
              <span class="icon-thumbnail">U</span>
            </li> -->
            <router-link title="View As" v-if="user_permission.data.myUserportal_view_as"  tag="li" class="hide_after_click" :to="{ name: 'viewasNew'}">
              <a>View As</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <!-- name: 'customize_new' -->
            <router-link title="Customise User Portal" v-if="user_permission.data.myUserportal_view_as"  tag="li" class="hide_after_click" :to="{ name: 'customize_new'}">
              <a>Customise User Portal</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link title="Customise Login Page" v-if="user_permission.data.customise_login_page"  tag="li" class="hide_after_click" :to="{ name: 'customize_login_new'}">
              <a>Customise Login Page</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link title="News Updates" tag="li" v-if="user_permission.data.news_updates"  class="hide_after_click" :to="{ name: 'news_updates_new',}">
              <a>News Updates</a>
              <span class="icon-thumbnail">N</span>
            </router-link>
            <!--
              User Portal Traffic. Gated on the existing all_reports permission — there is no
              dedicated "Portal Logins" permission row yet, and a key with no permissions record
              would evaluate falsy and hide the page from everyone.
            -->
            <router-link title="Portal Logins" tag="li" class="hide_after_click" v-if="user_permission.data.all_reports" :to="{ name: 'report.userportaltraffic'}">
              <a>Portal Traffic</a>
              <span class="icon-thumbnail">PL</span>
            </router-link>
          </ul>
        </li>
          <!-- <li>
          <a id="sidebar-user-portal" href="javascript:;" title="Exported"><span class="title title_sup">Exported <sup>New</sup></span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-file"></i></span>
          <ul class="sub-menu">
            <router-link title="Exported Files" tag="li" class="hide_after_click" :to="{ name: 'report.exported_files'}">
              <a>Files</a>
              <span class="icon-thumbnail">F</span>
            </router-link>
          </ul>
        </li> -->

        <router-link title="Exported Files" tag="li"  id="exported_files" class="hide_after_click" :to="{ name: 'report.exported_files'}" v-if="user_permission.data.exported">
          <a id="sidebar-user-portal" href="javascript:;" title="Exported Files"><span class="title title_sup">Exported Files <sup>New</sup></span>
            </a>
          <span class="icon-thumbnail"><i class="fas fa-file-alt"></i></span>
        </router-link>

       <!-- <li v-if="user_permission.data.my_team_portal || user_permission.data.customise_team_portal || user_permission.data.team_portal_view_as">
        <a id="sidebar-user-portal" href="javascript:;" title="Team Portal"><span class="title title_sup">Team Portal <sup>New</sup></span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-user"></i></span>
          <ul class="sub-menu">
            <li title="My Team Portal" tag="li"  v-show="usersType!='3'" v-if="user_permission.data.my_team_portal"  class="hide_after_click" >
              <a :href="myTeamportal" target="_blank" >My Team Portal</a>
              <span class="icon-thumbnail">T</span>
            </li>
            <router-link title="View As" tag="li" v-if="user_permission.data.team_portal_view_as" class="hide_after_click" :to="{ name: 'viewasTeamportal'}">
              <a>View As</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link title="Customise Team Portal"  v-show="usersType!='3'" tag="li" v-if="user_permission.data.customise_team_portal" class="hide_after_click" :to="{ name: 'customizeTeamportal'}">
              <a>Customise Team Portal</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
          </ul>
        </li> -->

        <li id="teamportal" v-if="(user_permission.data.my_team_portal || user_permission.data.customise_team_portal || user_permission.data.team_portal_view_as) && (isAdmin == 2 || (teamPortalStatus.is_active_teamportal && teamPortalStatus.is_team_flag))">
        <a id="sidebar-user-portal" href="javascript:;" title="Team Portal"><span class="title title_sup">Team Portal <sup>New</sup></span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-user"></i></span>
          <ul class="sub-menu">
            <!-- <li title="My Team Portal" tag="li"  v-show="usersType!='3'" v-if="user_permission.data.my_team_portal"  class="hide_after_click" > -->
            <!-- <li title="My Team Portal" tag="li" v-if="user_permission.data.my_team_portal && myTeamportal"  class="hide_after_click" >
              <a :href="myTeamportal" target="_blank" >My Team Portal</a>
              <span class="icon-thumbnail">T</span>
            </li> -->
            <router-link title="View As" tag="li" v-if="user_permission.data.team_portal_view_as" class="hide_after_click" :to="{ name: 'viewasTeamportal'}">
              <a>View As</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
            <router-link title="Customise Team Portal"  v-show="usersType!='3'" tag="li" v-if="user_permission.data.customise_team_portal" class="hide_after_click" :to="{ name: 'customizeTeamportal'}">
              <a>Customise Team Portal</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
          </ul>
        </li>

        <router-link id="admin_log" tag="li" class="hide_after_click" title="Admin Activity Logs" :to="{ name: 'adminLogs'}" v-if="user_permission.data.status==2">
          <a href=""><span class="title">Admin Logs</span>
          <span class="arrow invisible"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-clipboard-list"></i></span>
        </router-link>

        <li id="sidebar-settings" data-intro="Manage all company settings from here." data-position='right' v-if="user_permission.data.domain || user_permission.data.general || user_permission.data.user_management || user_permission.data.retest_frequency || user_permission.data.email_setting || user_permission.data.throttling_speed || user_permission.data.data_entry_oops_page || user_permission.data.landing_page_templates || user_permission.data.notifications || user_permission.data.ignore_ip_list || user_permission.data.passing_percentage || user_permission.data.leaderboard_settings || user_permission.data.training_login_template || user_permission.data.security || user_permission.data.change_password || user_permission.data.import_reporters">
          <a href="javascript:;"><span class="title">Settings</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-cog"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'general'}" v-if="user_permission.data.general">
              <a>General</a>
              <span class="icon-thumbnail">G</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'customizeAdminLogin'}">
              <a>Admin Login Page</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link class="hide_after_click" tag="li" :to="{ name: 'company.domains'}"   v-if="user_permission.data.domains">
              <a>Domains  </a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link class="hide_after_click" tag="li" :to="{ name: 'appCredentials'}"   v-if="user_permission.data.domains">
              <a>Channel Credentials</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link class="hide_after_click" tag="li" :to="{ name: 'O365Setup'}"   v-if="user_permission.data.domains">
              <a>O365 Settings</a>
              <span class="icon-thumbnail">O</span>
            </router-link>
            <router-link class="hide_after_click" tag="li" :to="{ name: 'aiSettings'}"   v-if="needlePhishingStatus">
              <a>AI Settings</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'email'}" v-if="user_permission.data.email_settings">
              <a>Email Settings</a>
              <span class="icon-thumbnail">E</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'credentials'}" v-if="user_permission.data.email_settings">
              <a>Reply To - Credentials</a>
              <span class="icon-thumbnail">R</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'throttling_sending_speed'}" v-if="user_permission.data.throttling_speed">
              <a>Throttling Speed</a>
              <span class="icon-thumbnail">T</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'trainingmail'}" v-if="user_permission.data.auto_reminder_mail">
              <a>Auto Reminder Mail</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'usermanagement'}" v-if="user_permission.data.user_management">
              <a>User Management</a>
              <span class="icon-thumbnail">U</span>
            </router-link>
           	<router-link tag="li" class="hide_after_click" :to="{ name: 'oopspage'}" v-if="user_permission.data.data_entry_oops_page">
              <a>Data Entry Oops Page</a>
              <span class="icon-thumbnail">D</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'master_landing'}" v-if="user_permission.data.landing_page_templates">
              <a>Landing Page Templates</a>
              <span class="icon-thumbnail">L</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'import_trained_users'}" v-if="user_permission.data.import_trained_users">
              <a>Import Trained Users</a>
              <span class="icon-thumbnail">I</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'notifications'}" v-if="user_permission.data.notifications">
              <a>Notifications</a>
              <span class="icon-thumbnail">N</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'ignore_list'}" v-if="user_permission.data.ignore_ip_list">
              <a>Ignore IP List</a>
              <span class="icon-thumbnail">I</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'books'}" v-if="user_permission.data.passing_percentage">
              <a>Passing Percentage</a>
              <span class="icon-thumbnail">P</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'training_languages' }">
              <a>Training Languages</a>
              <span class="icon-thumbnail">T</span>
            </router-link>

            <!-- <router-link tag="li" class="hide_after_click" :to="{ name: 'ip.index'}">
              <a>IP Infomation nnn</a>
              <span class="icon-thumbnail">I</span>
            </router-link>  -->




            <!-- <router-link tag="li" class="hide_after_click" :to="{ name: 'dl_invitation_mail'}" v-if="user_permission.data.training_invitation_mail">
              <a>Training Invitation Mail</a>
              <span class="icon-thumbnail">T</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'dl_login_with_password_mail'}" v-if="user_permission.data.training_login_template">
              <a>Training Login Template</a>
              <span class="icon-thumbnail">T</span>
            </router-link> -->
            <router-link tag="li" class="hide_after_click" :to="{ name: 'security'}" v-if="user_permission.data.security">
							<a>Security</a>
							<span class="icon-thumbnail">S</span>
						</router-link>
						<router-link tag="li" class="hide_after_click" :to="{ name: 'import_reporters'}" v-if="user_permission.data.import_reporters">
							<a>Import Reporters</a>
							<span class="icon-thumbnail">I</span>
						</router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'changepassword'}" v-if="user_permission.data.change_password">
              <a>Change Password</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'pdfCampaign'}" v-if="isActivePdfCampaign">
              <a>PDF Campaign</a>
              <span class="icon-thumbnail">P</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'campaignUserRole'}">
              <a>Campaign User Role</a>
              <span class="icon-thumbnail">C</span>
            </router-link>

          </ul>
        </li>
        <li id="ip_information" data-intro="ip_information" data-position='right' >
          <a href="javascript:;"><span class="title">IP Infomation</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-map-marker"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'ip.index'}">
              <a>Campaigns IP</a>
              <span class="icon-thumbnail">C</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'ip.announcementIp'}">
              <a>Announcements IP</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
          </ul>
        </li>
        <li id="active_directory_nav"  data-intro="Manage Active Directory settings here!" data-position='right' v-if="user_permission.data.ad_servers || user_permission.data.active_directory_view_logs">
          <a href="javascript:;"><span class="title">Active Directory</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-folder"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'listad'}" v-if="user_permission.data.ad_servers">
              <a>AD Servers</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'alladlogs'}" v-if="user_permission.data.active_directory_view_logs">
              <a>View Logs</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
          </ul>
        </li>
        <li id="sidebar-azure-active-dir" data-intro="Manage Azure Active Dir settings here!" data-position='right' v-if="user_permission.data.azure_active_directory_authorization">
          <a href="javascript:;"><span class="title">Azure Active Dir</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-folder"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'azure'}" v-if="user_permission.data.azure_active_directory_authorization">
              <a>Authorization</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
          </ul>
        </li>
        <!-- <li  data-intro="" data-position='right' v-if="user_permission.data.hris_vsms_directory_service || user_permission.data.hris_vsms_directory_service_logs">
          <a href="javascript:;"><span class="title">HRIS and VSMS</span>
          <span class="arrow"></span></a>
          <span class="icon-thumbnail"><i class="fas fa-folder"></i></span>
          <ul class="sub-menu">
            <router-link tag="li" class="hide_after_click" :to="{ name: 'HRISandVSMS'}" v-if="user_permission.data.hris_vsms_directory_service">
              <a>HRIS - VSMS Directory Service</a>
              <span class="icon-thumbnail">A</span>
            </router-link>
            <router-link tag="li" class="hide_after_click" :to="{ name: 'HRISandVSMSlogs'}" v-if="user_permission.data.hris_vsms_directory_service_logs">
              <a>View Logs</a>
              <span class="icon-thumbnail">V</span>
            </router-link>
          </ul>
        </li> -->
      </ul>
    </div>
  </nav>
</template>
<script>
import { lmsUrl, hfv3Url } from '../../config'
import { readStoredUser } from 'utils/storedUser'
export default {
	data() {
		return {
      showBoth:false,
			user_permission:{
				data: {
          endUserPortal:'',
					campaign_view: false,
					campaign_create: false,
					campaign_schedule: false,
					announcement_view: false,
					announcement_create: false,
					view_recepients:false,
					add_new_recepients:false,
					view_report: false,
					add_new_report: false,
					domain: false,
					general: false,
					user_management: false,
					retest_frequency: false,
					direct_learning_management: false,
					training_invitation_mail: false,
					training_login_template: false,
					data_entry_oops_page: false,
					training_mail: false,
					email_setting: false,
          userportal_active_version:{
            userportal: "v1"
          },
          app_theme:{},
					company_logo: {
						logo: '',
					},
					lmsUrl:lmsUrl,
          hfv3Url:hfv3Url,
				},
			},
      myUserportal:'',
      myTeamportal:'',
      teamPortalStatus: {
        is_active_teamportal: false,
        status: 1,
        is_team_flag: false,
      },
      needlePhishingStatus: false,
      usersType:0,
			loader:true,
      isAdmin: 1,
      adobeAcrobatStatus:false,
      isActivePdfCampaign:false,
      adminLogsEnabled: false,
      ouSettingStatus:false,
      userRole: '',
		}
	},
   created() {
    this.getOuSettingStatus()
    this.getAdobeAcrobatStatus()
    this.getpdfcampaignStatus()
    this.getAdminLogsStatus()
    // Always resolve the CURRENT user's role from the API — never trust the
    // per-origin cache. It could hold a previous user's role after another user
    // signed in on the same browser, showing the wrong approver/creator menus.
    this.getUserRole();
    this.$bus.$on('reloadafterPermissionUpdation',(val)=>{
      this.user_permission.data = JSON.parse(localStorage.getItem("permissions"));
      this.showHideUserPortal()
      this.getUserRole();
			this.setData()
    })
		const PERMISSIONS_TTL = 5 * 60 * 1000;
		let cachedPermissions = JSON.parse(localStorage.getItem("permissions"));
		let permTimestamp = parseInt(localStorage.getItem("permissions_ts") || '0');
		let isStale = (Date.now() - permTimestamp) > PERMISSIONS_TTL;

		if (!cachedPermissions || isStale) {
			this.$http.get('/setting/user_modules').then((response) => {
				this.user_permission.data = response.data.data;
				this.showHideUserPortal()
				this.loader = false;
				this.setData()
			})
		} else {
			this.user_permission.data = cachedPermissions;
			this.showHideUserPortal()
			this.setData()
		}
    this.getTeamPortalStatus();
    this.getNeedlePhishingStatus();
    // this.MyUserportalurl()

	},
	mounted() {
		// adding the script tag to the head as suggested before
		var head = document.getElementsByTagName('nav')[0];
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = '/static/pages/js/pages.js';
		// then bind the event to the callback function
		// there are several events for cross browser compatibility
		//   script.onreadystatechange = callback;
		//   script.onload = callback;
		// fire the loading
		head.appendChild(script);
		// require('../../../static/pages/js/pages.min.js');
		$(".modal-backdrop.fade.in").remove();
		window.onpopstate = function() {
			location.reload();
		}
    this.MyUserportalurl()
    // Guarded: this threw when the localStorage record was absent, and being the last statement
    // in mounted() it took the hook down with it. isAdmin keeps its default of 1 instead.
    const storedUser = readStoredUser()
    if (storedUser) {
      this.isAdmin = storedUser.status
    }
	},
	methods: {
    getOuSettingStatus(){
      this.$http.get('setting/ou-setting-status').then((response) => {
        this.ouSettingStatus = response.data && response.data.data && response.data.data.is_active_ou_setting;
      });
    },
    getUserRole(){
      this.$http.get('setting/user-role-name').then((response) => {
        const roleName = response.data.role_name || '';
        this.userRole = roleName;
        localStorage.setItem('campaignUserRole', roleName);
      }).catch(() => {
        // Keep any cached value on network error so the menu still renders.
        this.userRole = localStorage.getItem('campaignUserRole') || '';
      });
    },
    getpdfcampaignStatus(){
      this.$http.get('setting/pdf/campaign/status').then((response) => {
        this.isActivePdfCampaign = response.data.data.is_active_pdf_campaign;
      });
    },
    getAdobeAcrobatStatus(){
      this.$http.get('setting/adobe-acrobat/status').then((response) => {
        this.adobeAcrobatStatus = response.data.is_active_adobe_acrobat;
      });
    },
    getAdminLogsStatus(){
      this.$http.get('setting/admin-logs/status').then((response) => {
        this.adminLogsEnabled = response.data.admin_logs_enabled;
      }).catch(() => {
        this.adminLogsEnabled = false;
      });
    },
    getTeamPortalStatus(){
      this.$http.get('setting/get/teamportal/status')
        .then((response) => {
          this.teamPortalStatus = response.data.data
        });
    },
    getNeedlePhishingStatus(){
      this.$http.get('setting/needle/phishing/status')
        .then((response) => {
          this.needlePhishingStatus = response.data.data.is_active_needle_phishing
        });
    },
    showHideUserPortal(){
      if(this.user_permission.data && this.user_permission.data.userportal_active_version===undefined){
        this.showBoth = true;
      }
      else{
        this.showBoth=false;
      }
    },
    checkActive(val){
      return val ? '':'not-active'
    },
		setData() {
			var userpermissions = {
				'active_directory_view_logs':this.user_permission.data.active_directory_view_logs,
				'ad_servers':this.user_permission.data.ad_servers,
				'add_new_recepients':this.user_permission.data.add_new_recepients,
				'add_scenario':this.user_permission.data.add_scenario,
				'add_suppression':this.user_permission.data.add_suppression,
				'all_reports':this.user_permission.data.all_reports,
				'announcement_campaigns_new':this.user_permission.data.announcement_campaigns_new,
        'policy_announcement_new':this.user_permission.data.policy_announcement_new,
				'announcement_create':this.user_permission.data.announcement_create,
				'announcement_reports':this.user_permission.data.announcement_reports,
				'announcement_view':this.user_permission.data.announcement_view,
				'auto_reminder_mail':this.user_permission.data.auto_reminder_mail,
				'awareness_trend':this.user_permission.data.awareness_trend,
				'awareness_trend_new':this.user_permission.data.awareness_trend_new,
				'azure_active_directory_authorization':this.user_permission.data.azure_active_directory_authorization,
				'campaign_create':this.user_permission.data.campaign_create,
				'campaign_reports':this.user_permission.data.campaign_reports,
				'campaign_schedule':this.user_permission.data.campaign_schedule,
				'campaign_view':this.user_permission.data.campaign_view,
        'policy_create':this.user_permission.data.policy_create,
				'policy_view':this.user_permission.data.policy_view,
				'dashboard':this.user_permission.data.dashboard,
				'data_entry_oops_page':this.user_permission.data.data_entry_oops_page,
				'department_compromise':this.user_permission.data.department_compromise,
				'departments_new':this.user_permission.data.departments_new,
				'departments_vcro':this.user_permission.data.departments_vcro,
				'designation_compromise':this.user_permission.data.designation_compromise,
				'designations_new':this.user_permission.data.designations_new,
				'detailed_new':this.user_permission.data.detailed_new,
				'detailed_report':this.user_permission.data.detailed_report,
				'domains':this.user_permission.data.domains,
				'email_settings':this.user_permission.data.email_settings,
				'enrolments':this.user_permission.data.enrolments,
				'general':this.user_permission.data.general,
				'groups_vcro':this.user_permission.data.groups_vcro,
				'high_risk_users':this.user_permission.data.high_risk_users,
				'hris_vsms_directory_service':this.user_permission.data.hris_vsms_directory_service,
				'hris_vsms_directory_service_logs':this.user_permission.data.hris_vsms_directory_service_logs,
				'ignore_ip_list':this.user_permission.data.ignore_ip_list,
				'import_reporters':this.user_permission.data.import_reporters,
				'import_trained_users':this.user_permission.data.import_trained_users,
				'laggardsnew':this.user_permission.data.laggardsnew,
				'landing_page_templates':this.user_permission.data.landing_page_templates,
				'leaderboard_new':this.user_permission.data.leaderboard_new,
				'leaderboard_settings':this.user_permission.data.leaderboard_settings,
				'lms':this.user_permission.data.lms,
				'manage_groups':this.user_permission.data.manage_groups,
				'notifications':this.user_permission.data.notifications,
				'organisation_vcro':this.user_permission.data.organisation_vcro,
				'passing_percentage':this.user_permission.data.passing_percentage,
				'phishing_campaigns_new':this.user_permission.data.phishing_campaigns_new,
				'reporting_trend':this.user_permission.data.reporting_trend,
				'reporting_trend_new':this.user_permission.data.reporting_trend_new,
				'security':this.user_permission.data.security,
				'settings':this.user_permission.data.settings,
				'status':this.user_permission.data.status,
				'strongest_links':this.user_permission.data.strongest_links,
				'strongest_links_least_compromised_new':this.user_permission.data.strongest_links_least_compromised_new,
				'strongest_links_most_compromised_new':this.user_permission.data.strongest_links_most_compromised_new,
				'throttling_speed':this.user_permission.data.throttling_speed,
				'training_invitation_mail':this.user_permission.data.training_invitation_mail,
				'training_login_template':this.user_permission.data.training_login_template,
				'upload_modules':this.user_permission.data.upload_modules,
				'user_management':this.user_permission.data.user_management,
				'users_vcro':this.user_permission.data.users_vcro,
				'view_laggards':this.user_permission.data.view_laggards,
				'view_leaderboard':this.user_permission.data.view_leaderboard,
				'view_modules':this.user_permission.data.view_modules,
        'is_education_editable': this.user_permission.data.is_education_editable,
				'view_recepients':this.user_permission.data.view_recepients,
				'view_scenario':this.user_permission.data.view_scenario,
				'view_suppression':this.user_permission.data.view_suppression,
				'vulnerability_trend':this.user_permission.data.vulnerability_trend,
				'vulnerability_trend_new':this.user_permission.data.vulnerability_trend_new,
				'weakest_departments':this.user_permission.data.weakest_departments,
				'weakest_departments_new':this.user_permission.data.weakest_departments_new,
				'weakest_links':this.user_permission.data.weakest_links,
				'weakest_links_new':this.user_permission.data.weakest_links_new,
				'company_id':this.user_permission.data.company_id,
				'domain':this.user_permission.data.domain,
				'retest_frequency':this.user_permission.data.retest_frequency,
				'point_configure':this.user_permission.data.point_configure,
				'education_uploader':this.user_permission.data.education_uploader,
				'change_password':this.user_permission.data.change_password,
				'company_list' : this.user_permission.data.status == 2 ? true : false,
				'gamification_add_badgee' : this.user_permission.data.gamification_add_badgee,
				'gamification_award_log' : this.user_permission.data.gamification_award_log,
				'gamification_badges' : this.user_permission.data.gamification_badges,
				'gamification_set_points' : this.user_permission.data.gamification_set_points,
				'my_team_portal' : this.user_permission.data.my_team_portal,
				'customise_team_portal' : this.user_permission.data.customise_team_portal,
				'team_portal_view_as' : this.user_permission.data.team_portal_view_as,
				'myUserportal' : this.user_permission.data.myUserportal,
				'myUserportal_view_as' : this.user_permission.data.myUserportal_view_as,
				'customise_user_portal' : this.user_permission.data.customise_user_portal,
				'customise_login_page' : this.user_permission.data.customise_login_page,
				'news_updates' : this.user_permission.data.news_updates,
				'exported' : this.user_permission.data.exported,
        'app_theme': this.user_permission.data.app_theme
			};
			let sidebar_permissions = {
				'dashboard':this.user_permission.data.dashboard,
        'calendar' : true,
				'campaigns':this.user_permission.data.campaign_create || this.user_permission.data.campaign_view || this.user_permission.data.campaign_schedule,
				'announcements':this.user_permission.data.announcement_create || this.user_permission.data.announcement_view,
        'policy': this.user_permission.data.policy_create || this.user_permission.data.policy_view,
				'adobe_acrobat': this.adobeAcrobatStatus,
				'scenarios':this.user_permission.data.view_scenario || this.user_permission.data.add_scenario,
				'trainings':this.user_permission.data.view_modules || this.user_permission.data.upload_modules || this.user_permission.data.direct_learning_management || this.user_permission.data.education_uploader || this.user_permission.data.is_education_editable,
				'lms':this.user_permission.data.lms,
				'recipients':this.user_permission.data.view_recepients || this.user_permission.data.add_new_recepients || this.user_permission.data.manage_groups || this.user_permission.data.add_suppression || this.user_permission.data.view_suppression,
				'reports':this.user_permission.data.all_reports || this.user_permission.data.campaign_reports || this.user_permission.data.announcement_reports || this.user_permission.data.detailed_report || this.user_permission.data.view_leaderboard || this.user_permission.data.view_laggards || this.user_permission.data.vulnerability_trend || this.user_permission.data.awareness_trend || this.user_permission.data.reporting_trend || this.user_permission.data.weakest_links || this.user_permission.data.strongest_links || this.user_permission.data.weakest_departments || this.user_permission.data.high_risk_users || this.user_permission.data.department_compromise || this.user_permission.data.designation_compromise,
				'reportsnew':this.user_permission.data.phishing_campaigns_new || this.user_permission.data.announcement_campaigns_new || this.user_permission.data.policy_announcement_new || this.user_permission.data.leaderboard_new || this.user_permission.data.laggardsnew,
				'newmanagement_reports':this.user_permission.data.vulnerability_trend_new || this.user_permission.data.awareness_trend_new || this.user_permission.data.reporting_trend_new || this.user_permission.data.weakest_links_new || this.user_permission.data.strongest_links_least_compromised_new || this.user_permission.data.strongest_links_most_compromised_new || this.user_permission.data.weakest_departments_new,
				'newvulnerability_reports':this.user_permission.data.departments_new || this.user_permission.data.designations_new,
				'vcronew':this.user_permission.data.organisation_vcro || this.user_permission.data.departments_vcro || this.user_permission.data.groups_vcro || this.user_permission.data.users_vcro,
				'newgamification_engine':this.user_permission.data.gamification_add_badgee || this.user_permission.data.gamification_award_log || this.user_permission.data.gamification_badges || this.user_permission.data.gamification_set_points,
				'user_portal_new':this.user_permission && this.user_permission.data.myUserportal || this.user_permission.data.myUserportal_view_as || this.user_permission.data.customise_user_portal || this.user_permission.data.customise_login_page || this.user_permission.data.news_updates,
				'exported_files':true,
        'teamportal':true,
        'admin_log':true,
				'settings':this.user_permission.data.domain || this.user_permission.data.general || this.user_permission.data.user_management || this.user_permission.data.retest_frequency || this.user_permission.data.email_setting || this.user_permission.data.throttling_speed || this.user_permission.data.data_entry_oops_page || this.user_permission.data.landing_page_templates || this.user_permission.data.notifications || this.user_permission.data.ignore_ip_list || this.user_permission.data.passing_percentage || this.user_permission.data.leaderboard_settings || this.user_permission.data.training_login_template || this.user_permission.data.security || this.user_permission.data.change_password || this.user_permission.data.import_reporters,
        'ip_information':true,
				'active_directory':this.user_permission.data.ad_servers || this.user_permission.data.active_directory_view_logs,
				'azure_active_dir':this.user_permission.data.azure_active_directory_authorization,
				'faq':true,
				'quickview':true,

			}
      if(this.user_permission.data && this.user_permission.data.userportal_active_version && this.user_permission.data.userportal_active_version.userportal){
        userpermissions.userportal_active_version = {
          'userportal':this.user_permission.data.userportal_active_version.userportal
        }
      }
			localStorage.setItem("s_permissions", JSON.stringify(sidebar_permissions));
			localStorage.setItem("permissions", JSON.stringify(userpermissions));
			localStorage.setItem("permissions_ts", Date.now().toString());
      this.$bus.$emit('permissions-updated', userpermissions);
		},
		redirectToLms(){
			var user = localStorage.getItem('user');
			var permissions = localStorage.getItem('permissions');
			var userObj = JSON.parse(user);

			this.$http.post(
				'setting/save_user_token',
				{ user: user,permissions:permissions }
			)
			.then((response) => {
				window.open(lmsUrl+'/lms/course?t='+userObj.token, "_blank");
				//window.location = lmsUrl+'/lms/course?t='+userObj.token;
				//window.location = 'http://localhost:8080/lms/course?t='+userObj.token;
			});
		},
    redirectToHFv3(){
			var user = localStorage.getItem('user');
      var userObj = JSON.parse(user);
      var permissions = localStorage.getItem('permissions');
      this.$http.post(
				'setting/save_user_token',
				{ user: user,permissions:permissions }
			)
			.then((response) => {
        var redirecturl = hfv3Url.replace('/login', '');
        var permissions = JSON.parse(localStorage.getItem("company_logo"));
        this.company_id = permissions.company_id;
        window.open(redirecturl + '?t=' + userObj.token + '&c=' + this.company_id, "_blank");
			});
		},
		MyUserportalurl() {
      let companyLogoData = JSON.parse(localStorage.getItem("company_logo"))
      if(companyLogoData){
      this.myUserportal   = companyLogoData.url;
      if(this.myUserportal){
        this.endUserPortal = companyLogoData.url.replace("userportal", "userportal-v2/en");
      }

      this.myTeamportal   = companyLogoData.team_url;
      this.usersType      = companyLogoData.type;
    }
      else{
        setTimeout(()=>{
    this.MyUserportalurl()
    },5000)
      }
		},
		redirectToMyUserportal() {
			window.open(this.myUserportal, "_blank");
		}
	}
}
</script>
<style scoped>
.not-active a,.not-active span{
  color:#929aac !important;
}
</style>



// WEBPACK FOOTER //
// sidebar.vue?5313a3f4